/**
 * Shared dot pattern SVG overlay.
 * Used on landing page dark sections, AuthLayout branding panel,
 * and light-mode app surfaces for brand continuity.
 */
export function DotPattern({
  className = '',
  id = 'dot-grid',
  fill = 'white',
}: {
  className?: string
  id?: string
  fill?: string
}) {
  return (
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <pattern
          id={id}
          x="0"
          y="0"
          width="24"
          height="24"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="2" cy="2" r="1.5" fill={fill} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  )
}
